// extracted by mini-css-extract-plugin
export default {"title":"EditButtonForm_title__D7mOq","rowContainer":"EditButtonForm_rowContainer__Gx9Ad","block":"EditButtonForm_block__d4x98"};